/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum PreselectionDateType {
  TODAY = 'TODAY',
  LAST24HOURS = 'LAST24HOURS',
  LASTWEEK = 'LASTWEEK',
  LASTMONTH = 'LASTMONTH',
  LAST3MONTHS = 'LAST3MONTHS',
  LAST6MONTHS = 'LAST6MONTHS',
  LASTYEAR = 'LASTYEAR',
  LAST2YEARS = 'LAST2YEARS',
  CUSTOM = 'CUSTOM'
}
